require('./event-details/sort-charities');

$(() => {
  const $teamTable = $('.js-team-data-table');
  const $dataTableSearchInput = $teamTable.closest('.dataTables_wrapper').find('div[id$=_filter] input');
  const $dataTableSearchInputWrapper = $teamTable.closest('.dataTables_wrapper').find('.dataTables_filter').parent();
  const $pledgeTeam = $('.js-pledge-team');

  const showMoreTeamMembers = function showTeamMembers() {
    const $this = $(this);
    const $moreTeams = $this.prev('.team-pledge__more-members');

    $moreTeams.removeClass('hidden');
    $this
      .html(window.RR.i18n.showLessLink)
      .removeClass('team-pledge__show-more')
      .addClass('team-pledge__show-less');
  };

  const showLessTeamMembers = function showLessTeamMembers() {
    const $this = $(this);
    const $moreTeams = $this.prev('.team-pledge__more-members');

    $moreTeams.addClass('hidden');
    $this
      .html(window.RR.i18n.showMoreLink)
      .removeClass('team-pledge__show-less')
      .addClass('team-pledge__show-more');
  };

  $dataTableSearchInput.removeClass('input-sm').addClass('form-control').attr('id', 'dataTableSearch');
  $dataTableSearchInputWrapper.removeClass('col-sm-6').addClass('col-xs-12 padding-left-0 margin-bottom-1');

  $pledgeTeam.on('click', '.team-pledge__show-more', showMoreTeamMembers);
  $pledgeTeam.on('click', '.team-pledge__show-less', showLessTeamMembers);
});
